import { CardDetailsHeader } from "@/components/Cards/View/Details/Header"
import { TransactionsCard } from "@/components/Transactions/Card"

export const CardTransactions = () => {
  return (
    <>
      <div className="main-content_one-card border">
        <CardDetailsHeader />
      </div>
      <TransactionsCard />
    </>
  )
}
